import React from "react"
import clsx from "clsx"
import MultiSelect from "../../Selects/MultiSelect"


class OrderFormBuilderRates extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'rates',
      'tab-pane': true
    })
    var inputs = this.props.all_rates.map(rate => {
      return {
        label_primary: rate.code,
        label_secondary: rate.name, 
        id: rate.id
      }
    })
    return (
      <div className={tabClasses} id="rates">
        <div className="row">
          <div className="col-md-12">
          { inputs.length 
          ? 
            <MultiSelect 
              header_primary="code"
              header_secondary="name"
              inputs={inputs}
              selected_inputs={this.props.rates}
              onChange={this.props.onChangeRates}/>
          :
            <div className="no-records">
              <span className="none">{I18n.t('none')}</span>
            </div>
          }
          </div>
        </div>
      </div>
    )
  }


  
}

export default OrderFormBuilderRates